var FloatingOneTapInternalEvents;
(function(FloatingOneTapInternalEvents) {
    FloatingOneTapInternalEvents["LOGIN_SUCCESS"] = 'floatingonetap: success login';
    FloatingOneTapInternalEvents["SHOW_FULL_AUTH"] = 'floatingonetap: show full auth';
    FloatingOneTapInternalEvents["START_AUTHORIZE"] = 'floatingonetap: start authorize';
    FloatingOneTapInternalEvents["NOT_AUTHORIZED"] = 'floatingonetap: not authorized';
})(FloatingOneTapInternalEvents || (FloatingOneTapInternalEvents = {}));

export { FloatingOneTapInternalEvents };
